import { Injectable, ɵɵdefineInjectable, ɵɵinject, APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { TRANSLOCO_LOADER, TranslocoService } from '@ngneat/transloco';
import { FnwConfig, mapToLocale, loadCredentials, FnwCredentialsService, WebappLoaderCompanionBaseModule } from '@farmnet/webapp-loader-companion';
import { HttpClient } from '@angular/common/http';
import { switchMap, take } from 'rxjs/operators';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/language/transloco-http-loader.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@farmnet/webapp-loader-companion';
class FnwTranslocoHttpLoader {
    /**
     * @param {?} http
     * @param {?} config
     */
    constructor(http, config) {
        this.http = http;
        this.config = config;
    }
    /**
     * @param {?} lang
     * @return {?}
     */
    getTranslation(lang) {
        if (this.config.getTranslation) {
            return this.config.getTranslation(lang);
        }
        else {
            return this.http.get(`/mod/${this.config.serviceName}/assets/i18n/${lang}.json`);
        }
    }
}
FnwTranslocoHttpLoader.ɵfac = function FnwTranslocoHttpLoader_Factory(t) { return new (t || FnwTranslocoHttpLoader)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc2.FnwConfig)); };
FnwTranslocoHttpLoader.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: FnwTranslocoHttpLoader, factory: FnwTranslocoHttpLoader.ɵfac, providedIn: 'root' });
/** @nocollapse */
FnwTranslocoHttpLoader.ctorParameters = () => [
    { type: HttpClient },
    { type: FnwConfig }
];
/** @nocollapse */ FnwTranslocoHttpLoader.ngInjectableDef = ɵɵdefineInjectable({ factory: function FnwTranslocoHttpLoader_Factory() { return new FnwTranslocoHttpLoader(ɵɵinject(HttpClient), ɵɵinject(FnwConfig)); }, token: FnwTranslocoHttpLoader, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FnwTranslocoHttpLoader, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ɵngcc2.FnwConfig }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    FnwTranslocoHttpLoader.prototype.http;
    /**
     * @type {?}
     * @private
     */
    FnwTranslocoHttpLoader.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/language/load-language.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const FALLBACK_LANG = 'de-DE';
/**
 * @param {?} credentialsService
 * @param {?} transloco
 * @return {?}
 */
function loadLanguage(credentialsService, transloco) {
    return (/**
     * @return {?}
     */
    () => {
        return credentialsService.credentials
            .pipe(switchMap((/**
         * @param {?} credentials
         * @return {?}
         */
        credentials => {
            /** @type {?} */
            const farmnetLocale = credentials.locale;
            /** @type {?} */
            const availableLangIds = getAvailableLanIds(transloco.getAvailableLangs());
            /** @type {?} */
            const activeLang = mapToLocale(farmnetLocale, availableLangIds);
            /** @type {?} */
            let fallbackLang = FALLBACK_LANG;
            /** @type {?} */
            const baseLang = getBaseLang(activeLang, availableLangIds);
            /** @type {?} */
            const isAlreadyFallback = baseLang === FALLBACK_LANG;
            if (baseLang && !isAlreadyFallback) {
                fallbackLang = [baseLang, FALLBACK_LANG];
            }
            transloco.setActiveLang(activeLang);
            transloco.setFallbackLangForMissingTranslation((/** @type {?} */ ({
                fallbackLang,
            })));
            return transloco.load(activeLang);
        })), take(1))
            .toPromise();
    });
}
/**
 * @param {?} activeLang
 * @param {?} availableLangs
 * @return {?}
 */
function getBaseLang(activeLang, availableLangs) {
    const [first, second] = activeLang.split('-');
    if (second) {
        // e-g- 'pl' does not have a dialect
        /** @type {?} */
        const index = availableLangs.indexOf(activeLang);
        /** @type {?} */
        const base = availableLangs[index - 1];
        if (base) {
            const [baseFirst, baseSecond] = base.split('-');
            if (baseFirst === first) {
                return base;
            }
        }
    }
    return undefined;
}
/**
 * @param {?} availableLangs
 * @return {?}
 */
function getAvailableLanIds(availableLangs) {
    /** @type {?} */
    const first = availableLangs[0];
    if (typeof first === 'string') {
        return (/** @type {?} */ (availableLangs));
    }
    return ((/** @type {?} */ (availableLangs))).map((/**
     * @param {?} availableLang
     * @return {?}
     */
    availableLang => availableLang.id));
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/language/locale-id.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} translocoService
 * @return {?}
 */
function localeId(translocoService) {
    return translocoService.getActiveLang();
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/webapp-loader-companion-transloco.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class WebappLoaderCompanionTranslocoModule {
    /**
     * @param {?} config
     * @return {?}
     */
    static forRoot(config) {
        return {
            ngModule: WebappLoaderCompanionTranslocoModule,
            providers: [
                {
                    provide: FnwConfig,
                    useValue: config,
                },
                {
                    provide: APP_INITIALIZER,
                    useFactory: loadCredentials,
                    deps: [FnwCredentialsService],
                    multi: true,
                },
                { provide: TRANSLOCO_LOADER, useClass: FnwTranslocoHttpLoader },
                {
                    provide: APP_INITIALIZER,
                    multi: true,
                    useFactory: loadLanguage,
                    deps: [FnwCredentialsService, TranslocoService],
                },
                {
                    provide: LOCALE_ID,
                    useFactory: localeId,
                    deps: [TranslocoService],
                },
            ],
        };
    }
}
WebappLoaderCompanionTranslocoModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: WebappLoaderCompanionTranslocoModule });
WebappLoaderCompanionTranslocoModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function WebappLoaderCompanionTranslocoModule_Factory(t) { return new (t || WebappLoaderCompanionTranslocoModule)(); }, imports: [[WebappLoaderCompanionBaseModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(WebappLoaderCompanionTranslocoModule, { imports: function () { return [WebappLoaderCompanionBaseModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WebappLoaderCompanionTranslocoModule, [{
        type: NgModule,
        args: [{
                imports: [WebappLoaderCompanionBaseModule]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/language/public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: lib/public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: farmnet-webapp-loader-companion-transloco.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { FALLBACK_LANG, FnwTranslocoHttpLoader, WebappLoaderCompanionTranslocoModule, getAvailableLanIds, loadLanguage, localeId };

//# sourceMappingURL=farmnet-webapp-loader-companion-transloco.js.map